import {
  AfterContentInit,
  Component,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Subscription} from 'rxjs';

declare var hbspt: any;

@Component({
  selector: 'app-become-customer-form',
  templateUrl: './become-customer-form.component.html',
  styleUrls: ['./become-customer-form.component.scss'],
})
export class BecomeCustomerFormComponent
  implements OnInit, OnDestroy, AfterContentInit
{
  form: UntypedFormGroup;
  categories: string[];
  private subscriptions: Subscription[] = [];

  constructor(
    public dialogRef: MatDialogRef<BecomeCustomerFormComponent>,
    @Inject(MAT_DIALOG_DATA) public tag: string
  ) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  ngAfterContentInit() {
    hbspt.forms.create({
      region: 'na1',
      portalId: '7080361',
      formId: 'c8e4c3b7-e26f-4539-ba4c-af802de8a096',
      target: '#bliKundForm',
    });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
